<template>
  <div class="promotions-component">
    <div class="tabs d-flex justify-space-between">
      <button
        :class="{ active: currentTab === 'promotions' }"
        class="tab"
        @click="setTab('promotions')"
      >
        Промокоды
      </button>
      <button
        :class="{ active: currentTab === 'discounts' }"
        class="tab"
        @click="setTab('discounts')"
      >
        Акции клиента
      </button>
    </div>

    <div v-if="currentTab === 'promotions'" class="promocodes-section">
      <h1 class="step-title font-weight-regular">
        Промокоды:
      </h1>
      <div class="button-group d-flex justify-between">
        <v-row dense class="justify-space-between">
          <v-col sm="5">
            <v-btn
              class="button button-back"
              width="100%"
              color="#F1F3F6"
              @click="stepBack"
            >
              <font-awesome-icon icon="chevron-left" />
              Вернуться назад
            </v-btn>
          </v-col>
          <v-col sm="5">
            <v-btn class="button button-apply" width="100%" color="#F1F3F6">
              <font-awesome-icon icon="check" />
              Применить
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <div class="search-code-section">
        <span class="label">Поиск:</span>
        <div class="d-flex align-center">
          <v-text-field
            v-model="codeText"
            hide-details="auto"
            class="search-field"
            flat
            solo
          />
          <v-btn class="button-clear font-weight-medium" @click="clearCodeText">
            <font-awesome-icon icon="times" />
            Очистить
          </v-btn>
        </div>
      </div>

      <div class="popular-codes-section">
        <span class="label">Популярные промокоды:</span>
        <v-row class="promo-codes flex-wrap">
          <v-col
            v-if="!codeText.length && !promocodes.length"
            sm="12"
            class="d-flex align-center justify-center"
          >
            <span class="d-block display-3 text-center">
              Начните вводить промокод
            </span>
          </v-col>
          <v-col
            v-if="codeText.length && !promocodes.length"
            sm="12"
            class="d-flex align-center justify-center"
          >
            <span class="d-block display-3 text-center">
              Нет подходящих кодов
            </span>
          </v-col>
          <v-col v-for="(code, i) in promocodes" :key="i" sm="3">
            <v-btn
              class="button text-normalize"
              width="100%"
              depressed
              @click="setPromocode(code.code)"
            >
              {{ code.code }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <v-keyboard v-model="codeText" />
    </div>

    <div v-if="currentTab === 'discounts'" class="promotions-section">
      <h1 class="step-title font-weight-regular">
        Акции клиента:
      </h1>
      <div class="button-group d-flex justify-between">
        <v-row dense class="justify-space-between">
          <v-col sm="5">
            <v-btn
              class="button button-back"
              width="100%"
              color="#F1F3F6"
              @click="stepBack"
            >
              <font-awesome-icon icon="chevron-left" />
              Вернуться назад
            </v-btn>
          </v-col>
          <v-col sm="5">
            <v-btn class="button button-apply" width="100%" color="#F1F3F6">
              <font-awesome-icon icon="check" />
              Применить
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="client-promotions">
        <v-row class="promo-codes flex-wrap">
          <v-col v-for="(code, i) in personalPromocodes" :key="i" sm="3">
            <v-btn
              class="button text-normalize"
              width="100%"
              depressed
              @click="setPromocode(code.code)"
            >
              {{ code.name }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <h1 class="step-title font-weight-regular">
        Акции:
      </h1>
      <div class="fox-promotions">
        <v-row>
          <v-col v-for="i in 3" :key="i">
            <div class="promotion d-flex align-center justify-center">
              <span class="font-weight-medium">
                Баннеры с мобильной версии сайта
              </span>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VKeyboard from '@/components/order-processing/new-order/keyboard/Keyboard'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'PromotionsWindow',
    components: {
      VKeyboard,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        currentTab: 'promotions',
        promocodes: [],
        personalPromocodes: [],
        codeText: '',
        timeout: null,
      }
    },
    watch: {
      codeText () {
        clearTimeout(this.timeout)
        if (this.codeText.length > 3) {
          this.timeout = setTimeout(() => {
            this.getPromocodes(this.codeText)
          }, 300)
        }
      },
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
      }),
    },
    mounted () {
      this.getPromocodes()
      this.getPersonalPromocodes()
    },
    methods: {
      setTab (tab) {
        this.currentTab = tab
      },
      getPromocodes (code = null) {
        const payload = {
          limit: 8,
          offset: 0,
          page: 1,
          type: 'all',
        }
        if (code) {
          payload.findCode = code
        }
        this.$store.dispatch('promocodes/fetchPromocodesList', payload)
          .then(res => {
            if (res.status === 200) {
              this.promocodes = res.data.items
            }
          })
      },
      getPersonalPromocodes () {
        const payload = {
          clientId: this.basket.client.id,
        }
        this.$store.dispatch('promocodes/fetchPersonalPromocodesList', payload)
          .then(res => {
            if (res.status === 200) {
              this.personalPromocodes = res.data.items
            }
          })
      },
      setPromocode (code) {
        const data = {
          promoCode: code,
        }
        const id = this.basket.id
        this.$store.dispatch('baskets/updateBasket', { data, id }).then(res => {
          if (res.status === 200) {
            this.showSuccessMessage('Промокод добавлен')
            this.$store.dispatch('baskets/fetchSingleBasket', id)
          } else {
            this.showErrorMessage(res.response.data.message)
          }
        })
      },
      clearCodeText () {
        if (this.codeText) {
          this.codeText = ''
          this.promocodes = []
          this.getPromocodes()
        }
      },
      stepBack () {
        this.$store.commit('newOrder/togglePromotionsWindow', false)
      },
    },
  }
</script>

<style lang="less" scoped>
.promotions-component {
  //padding-top: 30px;
  background-color: #fafafa;

  .tabs {
    margin-bottom: 33px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      flex: 1;
      outline: none;
      font-size: 24px;
      line-height: 21px;
      border-radius: 14px 14px 0 0;
      height: 57px;

      &.active {
        background-color: #191919;
        font-weight: 900;
        color: @color-primary;
      }
    }
  }

  .label {
    display: block;
    margin-bottom: 14px;
    font-size: 20px;
    line-height: 21px;
  }

  .step-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 33px;
  }

  .button {
    height: 80px;
    background-color: @color-secondary !important;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      color: @color-primary;

      svg {
        .fill-svg(@color-primary);
      }
    }
  }

  .promocodes-section {
    .button-group {
      margin-bottom: 30px;
    }

    .search-code-section {
      margin-bottom: 100px;

      .search-field {
        &.v-input--is-focused {
          &::v-deep {
            .v-input__slot {
              border: 2px solid @color-primary;
            }
          }
        }

        &::v-deep {
          .v-input__slot {
            height: 80px;
            background-color: #f1f3f6;
            border-radius: 15px;
          }
        }
      }

      .button-clear {
        height: 76px;
        margin-right: -12px;
        font-size: 15px;
        border-radius: 10px;
        margin-left: 33px;
        padding: 0 60px;
        background-color: #f1f3f6;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

        svg {
          width: 19px;
          height: 19px;
          margin-right: 5px;
          .fill-svg(@color-error);
        }
      }
    }

    .popular-codes-section {
      .promo-codes {
        min-height: 103px;
        .button {
          font-size: 24px;
          line-height: 18px;
        }
      }
    }
  }

  .promotions-section {
    .button-group {
      margin-bottom: 51px;
    }

    .client-promotions {
      margin-bottom: 26px;

      .button {
        font-size: 24px;
        line-height: 18px;
      }
    }

    .fox-promotions {
      .promotion {
        padding: 0 50px;
        width: 338px;
        height: 446px;
        background-color: @color-secondary;
        border-radius: 30px;
        text-align: center;

        span {
          color: #d0d5de;
          font-size: 22px;
          line-height: 23px;
        }
      }
    }
  }
}
</style>
